var getData = require('../GetData/GetData').GetData;
var processData = require('../ProcessData/ProcessData').ProcessData;
var sortData = require('../SortData/SortData').SortData;
var processSeriesData = require('../ProcessSeriesData/ProcessSeriesData').ProcessSeriesData;
var processXaxisData = require('../ProcessXaxisData/ProcessXaxisData').ProcessXaxisData;

// MULTILINE Graph render and extraction logics
var extractStructure = function(type, meta, data) {
    var title = {
        text: JSON.stringify(meta.title).replace(/^"|"$/g, '')
    };

    var yAxis;
    var tooltip;
    var legend;
    var exporting;
    var plotOptions;
    var markers = meta.chart.plotoptions.markers;

    if(meta.chart.template_mini == "true"){
        yAxis = {
            title: null,
            labels: {
                enabled: false
            }
        };
        tooltip = {
            enabled: false
        };
        legend = {
            enabled: false
        };
        exporting = {
            enabled: false
        };
        plotOptions = {
            series: {
                marker: {
                    enabled: false
                }
            }
        };
    } else {
        yAxis = {
            title: {
                text: JSON.stringify(meta.chart.yAxis.text).replace(/^"|"$/g, '')
            },
            labels: {
                enabled: true
            }
        };
        tooltip = {
            enabled: true
        };
        legend = {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom',
            itemStyle: {
                width: '750px'
            }
        };
        exporting = {
            enabled: true,
            chartOptions:{
                legend:{
                    enabled:true
                }
            },
            sourceWidth: 900,
            sourceHeight: 600
        };
        plotOptions = {
            series: {
                marker: {
                    enabled: markers
                }
            }
        };
    }

    return {
        title: title,
        yAxis: yAxis,
        tooltip: tooltip,
        legend: legend,
        exporting: exporting,
        plotOptions: plotOptions,
        keyLegend: meta.chart.legend.key,
        keySeries: meta.chart.series.values.key,
        keyXaxis: meta.chart.xAxis.key
    };
}

var extractData = function(type, meta, data) {

    var jsonString1 = JSON.stringify(meta.chart.legend.key);
    var ledendKey = JSON.parse(jsonString1);

    var jsonString2 = JSON.stringify(meta.chart.series.values.key);
    var seriesKey = JSON.parse(jsonString2);

    var jsonString3 = JSON.stringify(meta.chart.xAxis.key);
    var xAxisKey = JSON.parse(jsonString3);

    // 1. STEP: Get data from URL or embedded
    var rawData = getData(data);

    // 2. STEP: Combine keys
    var processedData = processData(rawData, ledendKey, seriesKey, xAxisKey);

    // 3. STEP: Sort data in string according to inserted keys
    var result = sortData(processedData);

    // 4. STEP: Make string for Series
    var series = processSeriesData(result);

    // 5. STEP: Make string for xAxis
    var template = meta.chart.template_mini;
    var xAxis = processXaxisData(result, template);

    return {
        xAxis: xAxis,
        series: series
    };
}

function isNumeric(value) {
    return /^\d+$/.test(value);
}

var render = function(htmlElement, graphType, graphStructure, graphData) {

    var isDataValid = true;

    if (_.isString(graphType)) {
        // DO NOTHING
    } else {
        isDataValid = false;
        console.log("GraphType must be a string. For this error check graph JS or Liferay template.");
    }

    if (_.isObject(graphStructure)) {
        // DO NOTHING
    } else {
        isDataValid = false;
        console.log("GraphStructure must be a object. For this error check graph JS.");
    }

    // First we check if the keys are the same
    if (graphStructure.keyLegend == graphStructure.keySeries || graphStructure.keyLegend == graphStructure.keyXaxis || graphStructure.keySeries == graphStructure.keyXaxis) {
        $(htmlElement).append(
            '<div class="alert alert-info alert-dismissable"> ' +
            '<br>Knižnica Highcharts za Pie graf pričakuje <strong>trije različni ključi</strong>.' +
            '<br>Prvi ključ vedno je <strong>string</strong>, drugi ključ je vedno <strong>število</strong>, ter tretji ključ je vedno <strong>string</strong>.' +
            '<br>Pričakovani JSON je:<br>[{ data: ["String1", 2, "String2"]}]' +
            '</div>' +
            '<div class="no-entries">' +
            '<i class="fa fa-info" aria-hidden="true"></i>' +
            'Graf ni mogoče izrisati.' +
            '</div>');

        isDataValid = false;
        return true;
    }

    // Second we check if the graphData is object
    if (_.isObject(graphData)) {

        // Then we check if the DATA in graphData is correct
        var checkGraphData = graphData.series;

        if (checkGraphData.length == 0) {

            $(htmlElement).append(
                '<div class="alert alert-info alert-dismissable"> ' +
                '<br>Knižnica Highcharts za Pie graf pričakuje <strong>trije različni ključi</strong>.' +
                '<br>Prvi ključ vedno je <strong>string</strong>, drugi ključ je vedno <strong>število</strong>, ter tretji ključ je vedno <strong>string</strong>.' +
                '<br>Pričakovani JSON je:<br>[{ data: ["String1", 2, "String2"]}]' +
                '</div>' +
                '<div class="no-entries">' +
                '<i class="fa fa-info" aria-hidden="true"></i>' +
                'Graf ni mogoče izrisati.' +
                '</div>');

            isDataValid = false;
            return true;
        }

        for (i = 0; i < checkGraphData.length; i++) {
            var tmp = checkGraphData[i];

            // Tmp.name should be string
            if (typeof tmp.name == 'string') {
                // Do nothing
            } else {

                $(htmlElement).append(
                    '<div class="alert alert-info alert-dismissable"> ' +
                    'Napaka, ki se je zgodila je povezana na ključa: <strong>' + graphStructure.keyLegend + '</strong>.' +
                    '<br>Knižnica Highcharts pričakuje, da bodo vrednosti podatkov za vaš ključ <strong>niz</strong>.' +
                    '<br>Bolj natančno, napaka se je zgodila, zaradi tega ker ste kot vrednosti za vas kluč zadali števila v naslednji obliki:<br>[{ data: [1, 2, 3, ... , 9999]}]' +
                    '<br>Pričakovani JSON je:<br>[{ data: ["niz1", "niz2", "niz3", ... , "nizX"]}]' +
                    '</div>' +
                    '<div class="no-entries">' +
                    '<i class="fa fa-info" aria-hidden="true"></i>' +
                    'Graf ni mogoče izrisati.' +
                    '</div>');

                isDataValid = false;
                return true;
            }

            // Tmp.data should be array of numbers
            if (_.isEmpty(tmp.data)) {
                // console.log("Array is not empty");
            } else if (!tmp.data.some(isNaN)) {
                // console.log("Array values are numbers");
            } else {

                $(htmlElement).append(
                    '<div class="alert alert-info alert-dismissable"> ' +
                    'Napaka, ki se je zgodila je povezana na ključa: <strong>' + graphStructure.keySeries + '</strong>.' +
                    '<br>Knižnica Highcharts pričakuje, da bodo vrednosti podatkov za vaš ključ <strong>števila</strong>.' +
                    '<br>Bolj natančno, napaka se je zgodila, zaradi tega ker ste kot vrednosti za vas kluč zadali števila v naslednji obliki:<br>[{ data: ["niz1", "niz2", "niz3", ... , "nizX"]}]' +
                    '<br>Pričakovani JSON je:<br>[{ data: [1, 2, 3, ... , 9999]}]' +
                    '</div>' +
                    '<div class="no-entries">' +
                    '<i class="fa fa-info" aria-hidden="true"></i>' +
                    'Graf ni mogoče izrisati.' +
                    '</div>');

                isDataValid = false;
                return true;
            }

        }
    } else {
        isDataValid = false;
        console.log("GraphData must be a object. For this error check graph JS.");
    }

    // Third we check if the data for xAxis is string
    var tmp2 = graphData.xAxis.categories;
    for (j = 0; j < tmp2.length; j++) {

        if (tmp2.length == 0) {
            $(htmlElement).append(
                '<div class="alert alert-info alert-dismissable"> ' +
                'Napaka, ki se je zgodila je povezana na ključa: <strong>' + graphStructure.keyXaxis + '</strong>.' +
                '<br>Knižnica Highcharts pričakuje, da bodo vrednosti podatkov za vaš ključ <strong>niz</strong>.' +
                '<br>Bolj natančno, napaka se je zgodila, zaradi tega ker ste kot vrednosti za vas kluč zadali števila v naslednji obliki:<br>[{ data: [1, 2, 3, ... , 9999]}]' +
                '<br>Pričakovani JSON je:<br>[{ data: ["niz1", "niz2", "niz3", ... , "nizX"]}]' +
                '</div>' +
                '<div class="no-entries">' +
                '<i class="fa fa-info" aria-hidden="true"></i>' +
                'Graf ni mogoče izrisati.' +
                '</div>');

            isDataValid = false;
            return true;
        }

        // Tmp2.[j] should be string
        if (_.isString(tmp2[j])) {} else {
            $(htmlElement).append(
                '<div class="alert alert-info alert-dismissable"> ' +
                'Napaka, ki se je zgodila je povezana na ključa: <strong>' + graphStructure.keyXaxis + '</strong>.' +
                '<br>Knižnica Highcharts pričakuje, da bodo vrednosti podatkov za vaš ključ <strong>niz</strong>.' +
                '<br>Bolj natančno, napaka se je zgodila, zaradi tega ker ste kot vrednosti za vas kluč zadali števila v naslednji obliki:<br>[{ data: [1, 2, 3, ... , 9999]}]' +
                '<br>Pričakovani JSON je:<br>[{ data: ["niz1", "niz2", "niz3", ... , "nizX"]}]' +
                '</div>' +
                '<div class="no-entries">' +
                '<i class="fa fa-info" aria-hidden="true"></i>' +
                'Graf ni mogoče izrisati.' +
                '</div>');

            isDataValid = false;
            return true;
        }

    }

    // Data is correct for all three keys. Draw the graph:
    //
    //
    ///
    ///
    if (isDataValid) {

        // lokalizacija za Liferay
        if ( Liferay.ThemeDisplay.getLanguageId() == "sl_SI" ) {
            Highcharts.setOptions({
                lang: {
                    contextButtonTitle: "Menijski element",
                    decimalPoint: ",",
                    downloadJPEG: "Prenesite JPEG sliko",
                    downloadPDF: "Prinesite PDF dokument",
                    downloadPNG: "Prenesite PNG sliko",
                    downloadSVG: "Prenesite SVG sliko",
                    drillUpText: "Nazaj na {series.name}",
                    // invalidDate: "",
                    loading: "Nalaganje...",
                    months: ["Januar", "Februar", "Marec", "April", "Maj", "Junij", "Julij", "Avgust", "September", "Oktober", "November", "December"],
                    noData: "No hi ha dades per mostrar",
                    // numericSymbolMagnitude: 1000,
                    // numericSymbols: [ "k" , "M" , "G" , "T" , "P" , "E"],
                    printChart: "Natisni sliko",
                    resetZoom: "Ponastavi povečavo",
                    resetZoomTitle: "Ponastavite raven povečave 1:1",
                    shortMonths: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Okt", "Nov", "Dec"],
                    shortWeekdays: undefined,
                    thousandsSep: ".",
                    weekdays: ["Nedelja", "Ponedeljek", "Torek", "Sreda", "Četrtek", "Petek", "Sobota"]
                },
				colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1", '#50b6e6', '#c4e538', '#fee02c', '#bfbfbf', '#ed4c67', '#b7e2f5', '#e0ff85', '#fff5ad', '#dddddd', '#f492a2', '#0652dd', '#009432', '#ee5a24', '#9980fa', '#833471', '#1289a7', '#9acc23', '#f79f1f', '#d980fa', '#b53471', '#50b6b4', '#92e538', '#feae2c', '#bfbf8d', '#bb4c67', '#85e2f5', '#aeff85', '#fff57b', '#bebebe', '#f460a2', '#0684dd', '#00c632', '#f87753', '#cb80fa', '#b53471', '#1257a7', '#68cc23', '#f76d1f', '#d94efa', '#b5342a', '#50b6ff', '#92fe38', '#fe772c', '#bf85c4', '#bb7767', '#50e2f5', '#78ff85', '#fff544', '#a8a8a8', '#f429a2']

            });
        }
		// console.log("tu sem", graphData.series);
        // Draw the graph:
        $(htmlElement).highcharts({
			boost: {
				useGPUTranslations: true
			},
            title: graphStructure.title,
            xAxis: graphData.xAxis,
            yAxis: graphStructure.yAxis,
            tooltip: graphStructure.tooltip,
            legend: graphStructure.legend,
            exporting: graphStructure.exporting,
            plotOptions: graphStructure.plotOptions,
            series: graphData.series,
			
			
            credits: {
                enabled: false
            },		
            navigation: {
                buttonOptions: {
                    height: 40,
                    width: 48,
                    symbolSize: 24,
                    symbolX: 23,
                    symbolY: 21,
                    symbolStrokeWidth: 2
              }
            }
        });
    }
};

module.exports = {
    extractStructure: extractStructure,
    extractData: extractData,
    render: render,
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/DataGraph/LineMultilineGraph.js
// module id = 12
// module chunks = 0